import register from "preact-custom-element";
import { useEffect, useRef } from "preact/hooks";
import InfiniteMarquee from "vanilla-infinite-marquee";

function MarqueeContent({ content, mobile_space, desktop_space }) {
  const sectionRef = useRef();

  useEffect(() => {
    new InfiniteMarquee({
      element: sectionRef.current.querySelector("div"),
      speed: 150000,
      smoothEdges: false,
      direction: "left",
      spaceBetween: `${desktop_space}px`,
      duplicateCount: 2,
      mobileSettings: {
        spaceBetween: `${mobile_space}px`,
        speed: 100000,
      },
      on: {
        beforeInit: () => {
          console.log("Not Yet Initialized");
        },

        afterInit: () => {
          console.log("Initialized");
        },
      },
    });
  }, []);

  return <div ref={sectionRef}>{content}</div>;
}

register(MarqueeContent, "marquee-content", []);
